export default "__VITE_ASSET__BYCebXnf__"